import React from "react";
import classes from "./cursor-selection.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVectorSquare } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import { Tooltip } from "antd";
import { POINTER_MODES } from "../../../../constants/editor";
import { isNil } from "ramda";

const CursorSelection = ({ selectionData, isActive, onChangeMode }) => {
  return (
    <div className={classNames(classes.PositionWrap, "text-primary")}>
      <Tooltip title="Selection">
        <FontAwesomeIcon
          onClick={() => onChangeMode(POINTER_MODES.SELECTION)}
          icon={faVectorSquare}
          className={classNames(classes.Icon, {
            [classes.ActiveIcon]: isActive,
          }, isActive ? "text-danger" : "")}
        />
      </Tooltip>
      <span className={classNames(classes.PositionData, "text-primary")}>
        {!isActive || isNil(selectionData)
          ? " - , - , - , - "
          : (selectionData[0]
              ? Math.round(selectionData[0] * 10) / 10
              : " - ") +
            ", " +
            (selectionData[0]
              ? Math.round(selectionData[1] * 10) / 10
              : " - ") +
            ", " +
            (selectionData[0]
              ? Math.round(selectionData[2] * 10) / 10
              : " - ") +
            ", " +
            (selectionData[0] ? Math.round(selectionData[3] * 10) / 10 : " - ")}
      </span>
    </div>
  );
};

export default CursorSelection;
